import React, { useState, useEffect } from "react";
import eclPasswordValidator from "./eclPasswordValidator";
import "./ECLPasswordValidatorUI.css";
import { ECLPassword, ECLThemeImage } from "../../../index";

export default function ECLPasswordValidatorUI(props) {
   //PROPS
   // id={props.passwordId} for ECLPassword
   // password={props.password}  for ECLPassword
   // setPassword={props.setPassword}  for ECLPassword
   // placeholder={props.placeholder} for ECLPassword
   // pattern = {props.pattern} for ECLPassword
   // setPasswordValidity - function- to pass validity of the password to it's parent form to stop/allow submission
   // username = string - can't be called from user context bc of utility page cases

   const [validationRules, setValidationRules] = useState({});
   const [passwordValid, setPasswordValid] = useState(false);

   useEffect(() => {
      const validationObject = eclPasswordValidator(
         props.password,
         props.username,
      );
      setValidationRules(validationObject.validationRules);
      setPasswordValid(validationObject.inputValid);
      props.setPasswordValidity &&
         props.setPasswordValidity(validationObject.inputValid);
   }, [props.password]);

   return (
      <div className="password-validator-ui">
         <ECLPassword
            id={props.passwordId}
            password={props.password}
            setPassword={props.setPassword}
            placeholder={props.placeholder}
            pattern={props.pattern}
         />
         <div className="validation-container">
            <div className="validation-rules">
               {Object.keys(validationRules).map((rule, index) => {
                  let validationClass = "valid";
                  if (!validationRules[rule].passed) {
                     validationClass = "invalid";
                  }

                  let string = "";
                  if (index === 0) {
                     string = "Use";
                  }
                  string += " " + validationRules[rule].message;

                  if (index < Object.keys(validationRules).length - 3) {
                     //the last 2 rules get different punctuation
                     string += ", ";
                  } else if (
                     index ===
                     Object.keys(validationRules).length - 3
                  ) {
                     string += ", and ";
                  } else if (
                     index ===
                     Object.keys(validationRules).length - 2
                  ) {
                     string += ". ";
                  } else {
                     return (
                        <span
                           key={rule}
                           className={"last-rule " + validationClass}
                        >
                           {string}
                        </span>
                     );
                  }
                  return (
                     <span key={rule} className={validationClass}>
                        {string}
                     </span>
                  );
               })}
            </div>
            {!passwordValid && (
               <ECLThemeImage
                  fontAwesome="circle-exclamation"
                  colorOverride="red"
                  style={{ height: "25px", width: "25px", minWidth: "25px" }}
               />
            )}
         </div>
      </div>
   );
}
